var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoweredBy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 50,
    viewBox: "0 0 136 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.10742 8.81836H1.88672V7.65234H4.10742C4.49414 7.65234 4.80664 7.58984 5.04492 7.46484C5.2832 7.33984 5.45703 7.16797 5.56641 6.94922C5.67969 6.72656 5.73633 6.47266 5.73633 6.1875C5.73633 5.91797 5.67969 5.66602 5.56641 5.43164C5.45703 5.19336 5.2832 5.00195 5.04492 4.85742C4.80664 4.71289 4.49414 4.64062 4.10742 4.64062H2.33789V12H0.867188V3.46875H4.10742C4.76758 3.46875 5.32812 3.58594 5.78906 3.82031C6.25391 4.05078 6.60742 4.37109 6.84961 4.78125C7.0918 5.1875 7.21289 5.65234 7.21289 6.17578C7.21289 6.72656 7.0918 7.19922 6.84961 7.59375C6.60742 7.98828 6.25391 8.29102 5.78906 8.50195C5.32812 8.71289 4.76758 8.81836 4.10742 8.81836ZM15.334 7.5V7.96875C15.334 8.61328 15.25 9.19141 15.082 9.70312C14.9141 10.2148 14.6738 10.6504 14.3613 11.0098C14.0527 11.3691 13.6816 11.6445 13.248 11.8359C12.8145 12.0234 12.334 12.1172 11.8066 12.1172C11.2832 12.1172 10.8047 12.0234 10.3711 11.8359C9.94141 11.6445 9.56836 11.3691 9.25195 11.0098C8.93555 10.6504 8.68945 10.2148 8.51367 9.70312C8.3418 9.19141 8.25586 8.61328 8.25586 7.96875V7.5C8.25586 6.85547 8.3418 6.2793 8.51367 5.77148C8.68555 5.25977 8.92773 4.82422 9.24023 4.46484C9.55664 4.10156 9.92969 3.82617 10.3594 3.63867C10.793 3.44727 11.2715 3.35156 11.7949 3.35156C12.3223 3.35156 12.8027 3.44727 13.2363 3.63867C13.6699 3.82617 14.043 4.10156 14.3555 4.46484C14.668 4.82422 14.9082 5.25977 15.0762 5.77148C15.248 6.2793 15.334 6.85547 15.334 7.5ZM13.8633 7.96875V7.48828C13.8633 7.01172 13.8164 6.5918 13.7227 6.22852C13.6328 5.86133 13.498 5.55469 13.3184 5.30859C13.1426 5.05859 12.9258 4.87109 12.668 4.74609C12.4102 4.61719 12.1191 4.55273 11.7949 4.55273C11.4707 4.55273 11.1816 4.61719 10.9277 4.74609C10.6738 4.87109 10.457 5.05859 10.2773 5.30859C10.1016 5.55469 9.9668 5.86133 9.87305 6.22852C9.7793 6.5918 9.73242 7.01172 9.73242 7.48828V7.96875C9.73242 8.44531 9.7793 8.86719 9.87305 9.23438C9.9668 9.60156 10.1035 9.91211 10.2832 10.166C10.4668 10.416 10.6855 10.6055 10.9395 10.7344C11.1934 10.8594 11.4824 10.9219 11.8066 10.9219C12.1348 10.9219 12.4258 10.8594 12.6797 10.7344C12.9336 10.6055 13.1484 10.416 13.3242 10.166C13.5 9.91211 13.6328 9.60156 13.7227 9.23438C13.8164 8.86719 13.8633 8.44531 13.8633 7.96875ZM18.9434 10.084L20.6426 3.46875H21.5332L21.4336 5.17383L19.6172 12H18.6914L18.9434 10.084ZM17.6719 3.46875L19.0488 10.0312L19.1719 12H18.1875L16.2129 3.46875H17.6719ZM23.4609 10.0137L24.8203 3.46875H26.2852L24.3105 12H23.3262L23.4609 10.0137ZM21.8789 3.46875L23.5605 10.1016L23.8066 12H22.8809L21.0938 5.17383L21 3.46875H21.8789ZM32.959 10.834V12H28.4297V10.834H32.959ZM28.8457 3.46875V12H27.375V3.46875H28.8457ZM32.3672 7.03125V8.17969H28.4297V7.03125H32.3672ZM32.9297 3.46875V4.64062H28.4297V3.46875H32.9297ZM34.1602 3.46875H37.1777C37.8262 3.46875 38.3789 3.56641 38.8359 3.76172C39.293 3.95703 39.6426 4.24609 39.8848 4.62891C40.1309 5.00781 40.2539 5.47656 40.2539 6.03516C40.2539 6.46094 40.1758 6.83594 40.0195 7.16016C39.8633 7.48438 39.6426 7.75781 39.3574 7.98047C39.0723 8.19922 38.7324 8.36914 38.3379 8.49023L37.8926 8.70703H35.1797L35.168 7.54102H37.2012C37.5527 7.54102 37.8457 7.47852 38.0801 7.35352C38.3145 7.22852 38.4902 7.05859 38.6074 6.84375C38.7285 6.625 38.7891 6.37891 38.7891 6.10547C38.7891 5.80859 38.7305 5.55078 38.6133 5.33203C38.5 5.10938 38.3242 4.93945 38.0859 4.82227C37.8477 4.70117 37.5449 4.64062 37.1777 4.64062H35.6309V12H34.1602V3.46875ZM39.0293 12L37.0254 8.16797L38.5664 8.16211L40.5996 11.9238V12H39.0293ZM47.3027 10.834V12H42.7734V10.834H47.3027ZM43.1895 3.46875V12H41.7188V3.46875H43.1895ZM46.7109 7.03125V8.17969H42.7734V7.03125H46.7109ZM47.2734 3.46875V4.64062H42.7734V3.46875H47.2734ZM50.9824 12H49.1602L49.1719 10.834H50.9824C51.5098 10.834 51.9512 10.7188 52.3066 10.4883C52.666 10.2578 52.9355 9.92773 53.1152 9.49805C53.2988 9.06836 53.3906 8.55664 53.3906 7.96289V7.5C53.3906 7.03906 53.3379 6.63086 53.2324 6.27539C53.1309 5.91992 52.9785 5.62109 52.7754 5.37891C52.5762 5.13672 52.3301 4.95312 52.0371 4.82812C51.748 4.70312 51.4141 4.64062 51.0352 4.64062H49.125V3.46875H51.0352C51.6016 3.46875 52.1191 3.56445 52.5879 3.75586C53.0566 3.94336 53.4609 4.21484 53.8008 4.57031C54.1445 4.92578 54.4082 5.35156 54.5918 5.84766C54.7754 6.34375 54.8672 6.89844 54.8672 7.51172V7.96289C54.8672 8.57617 54.7754 9.13086 54.5918 9.62695C54.4082 10.123 54.1445 10.5488 53.8008 10.9043C53.457 11.2559 53.0469 11.5273 52.5703 11.7188C52.0977 11.9062 51.5684 12 50.9824 12ZM49.9746 3.46875V12H48.5039V3.46875H49.9746ZM62.5312 8.14453H60.3574L60.3457 7.07227H62.2441C62.5645 7.07227 62.8359 7.02539 63.0586 6.93164C63.2852 6.83398 63.457 6.69531 63.5742 6.51562C63.6914 6.33203 63.75 6.11133 63.75 5.85352C63.75 5.56836 63.6953 5.33594 63.5859 5.15625C63.4766 4.97656 63.3086 4.8457 63.082 4.76367C62.8594 4.68164 62.5742 4.64062 62.2266 4.64062H60.8027V12H59.332V3.46875H62.2266C62.6953 3.46875 63.1133 3.51367 63.4805 3.60352C63.8516 3.69336 64.166 3.83398 64.4238 4.02539C64.6855 4.21289 64.8828 4.45117 65.0156 4.74023C65.1523 5.0293 65.2207 5.37305 65.2207 5.77148C65.2207 6.12305 65.1367 6.44531 64.9688 6.73828C64.8008 7.02734 64.5527 7.26367 64.2246 7.44727C63.8965 7.63086 63.4883 7.74023 63 7.77539L62.5312 8.14453ZM62.4668 12H59.8945L60.5566 10.834H62.4668C62.7988 10.834 63.0762 10.7793 63.2988 10.6699C63.5215 10.5566 63.6875 10.4023 63.7969 10.207C63.9102 10.0078 63.9668 9.77539 63.9668 9.50977C63.9668 9.23242 63.918 8.99219 63.8203 8.78906C63.7227 8.58203 63.5684 8.42383 63.3574 8.31445C63.1465 8.20117 62.8711 8.14453 62.5312 8.14453H60.8789L60.8906 7.07227H63.041L63.375 7.47656C63.8438 7.49219 64.2285 7.5957 64.5293 7.78711C64.834 7.97852 65.0605 8.22656 65.209 8.53125C65.3574 8.83594 65.4316 9.16406 65.4316 9.51562C65.4316 10.0586 65.3125 10.5137 65.0742 10.8809C64.8398 11.248 64.502 11.5273 64.0605 11.7188C63.6191 11.9062 63.0879 12 62.4668 12ZM67.4004 3.46875L69.3809 7.54102L71.3613 3.46875H72.9902L70.1191 8.85938V12H68.6367V8.85938L65.7656 3.46875H67.4004Z",
    fill: "#BBBEFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3129_5567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.1102 38.1272C49.1785 38.5666 47.9755 38.7862 46.4776 38.7862C44.5316 38.7862 42.9983 38.2197 41.8779 37.0983C40.7575 35.9769 40.2031 34.4854 40.2031 32.6125C40.2031 30.624 40.8282 29.0054 42.0902 27.7683C43.3404 26.5313 44.968 25.907 46.973 25.907C48.2114 25.907 49.2611 26.0573 50.1102 26.3694V29.0632C49.2611 28.5661 48.2939 28.3117 47.2089 28.3117C46.0177 28.3117 45.0505 28.6817 44.3193 29.41C43.5881 30.15 43.2224 31.1442 43.2224 32.3929C43.2224 33.5952 43.5645 34.5548 44.2603 35.2716C44.9562 35.9884 45.8761 36.3468 47.0438 36.3468C48.1642 36.3468 49.1785 36.0809 50.1102 35.5491V38.1272Z",
    fill: "#110626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0075 38.7863C54.4833 38.7863 53.2807 38.3438 52.4114 37.4588C51.5421 36.5738 51.1016 35.3815 51.1016 33.8696C51.1016 32.3085 51.5541 31.0794 52.459 30.2067C53.364 29.3217 54.5905 28.8792 56.1385 28.8792C57.6626 28.8792 58.8534 29.3217 59.7108 30.2067C60.58 31.0917 61.0087 32.2594 61.0087 33.7098C61.0087 35.2831 60.5681 36.5123 59.675 37.4342C58.782 38.3315 57.5555 38.7863 56.0075 38.7863ZM56.0789 31.1162C55.4121 31.1162 54.8882 31.3498 54.519 31.8292C54.1499 32.3085 53.9594 32.9723 53.9594 33.845C53.9594 35.6642 54.6738 36.5615 56.0908 36.5615C57.4483 36.5615 58.1151 35.6273 58.1151 33.7713C58.127 31.989 57.4483 31.1162 56.0789 31.1162Z",
    fill: "#110626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9047 38.5474H69.0687V37.0764H69.0207C68.3117 38.2205 67.3744 38.7863 66.1967 38.7863C64.0578 38.7863 62.9883 37.4284 62.9883 34.7128V28.8792H65.8242V34.4488C65.8242 35.8192 66.3409 36.4981 67.3744 36.4981C67.8911 36.4981 68.2997 36.3095 68.6001 35.9323C68.9125 35.5551 69.0567 35.0522 69.0567 34.411V28.8792H71.8927V38.5474H71.9047Z",
    fill: "#110626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8135 35.4445C76.8135 35.8398 76.9131 36.1272 77.0998 36.3308C77.2989 36.5345 77.5478 36.6303 77.8714 36.6303C78.0332 36.6303 78.195 36.6183 78.3568 36.5824C78.5186 36.5464 78.6804 36.5225 78.8422 36.4865V38.4868C78.4813 38.5826 78.1079 38.6545 77.7221 38.7024C77.3238 38.7623 76.9131 38.7862 76.4899 38.7862C76.0916 38.7862 75.7431 38.7263 75.4195 38.5946C75.0959 38.4628 74.8221 38.2832 74.5981 38.0556C74.3741 37.816 74.1998 37.5286 74.0754 37.1932C73.9509 36.8578 73.8887 36.4746 73.8887 36.0554V24.9163H76.826V35.4445H76.8135Z",
    fill: "#110626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.736 38.7863C83.2118 38.7863 82.0092 38.3438 81.1399 37.4588C80.2707 36.5738 79.8301 35.3815 79.8301 33.8696C79.8301 32.3085 80.2826 31.0794 81.1875 30.2067C82.0925 29.3217 83.319 28.8792 84.867 28.8792C86.3912 28.8792 87.5819 29.3217 88.4393 30.2067C89.3085 31.0917 89.7372 32.2594 89.7372 33.7098C89.7372 35.2831 89.2966 36.5123 88.4035 37.4342C87.5105 38.3315 86.284 38.7863 84.736 38.7863ZM84.8075 31.1162C84.1406 31.1162 83.6167 31.3498 83.2476 31.8292C82.8784 32.3085 82.6879 32.9723 82.6879 33.845C82.6879 35.6642 83.4024 36.5615 84.8194 36.5615C86.1768 36.5615 86.8437 35.6273 86.8437 33.7713C86.8556 31.989 86.1768 31.1162 84.8075 31.1162Z",
    fill: "#110626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.577 38.7863H102.702V33.2795C102.702 31.8714 102.203 31.1799 101.204 31.1799C100.729 31.1799 100.339 31.3936 100.047 31.8085C99.7424 32.236 99.5962 32.7515 99.5962 33.3801V38.7863H96.7093V33.2167C96.7093 31.8463 96.2221 31.1673 95.2354 31.1673C94.736 31.1673 94.3462 31.3685 94.0539 31.7708C93.7616 32.1731 93.6154 32.7263 93.6154 33.4178V38.7863H90.7285V29.118H93.6154V30.6267H93.6519C93.9565 30.1113 94.3706 29.6964 94.9066 29.3695C95.4425 29.0426 96.0394 28.8792 96.6728 28.8792C98.0005 28.8792 98.9019 29.4826 99.3891 30.677C100.108 29.4701 101.155 28.8792 102.532 28.8792C104.566 28.8792 105.589 30.1741 105.589 32.7641V38.7863H105.577Z",
    fill: "#110626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.546 37.4915H110.509V38.5585H107.57V24.9163H110.509V30.7304H110.546C111.278 29.6515 112.307 29.124 113.646 29.124C114.874 29.124 115.816 29.5316 116.485 30.3468C117.155 31.1619 117.477 32.2768 117.477 33.6914C117.477 35.2258 117.093 36.4606 116.312 37.3956C115.531 38.3307 114.502 38.7862 113.2 38.7862C112.046 38.7862 111.154 38.3547 110.546 37.4915ZM110.472 33.6075V34.5545C110.472 35.1539 110.645 35.6454 111.005 36.029C111.365 36.4246 111.811 36.6164 112.369 36.6164C113.038 36.6164 113.559 36.3647 113.931 35.8612C114.303 35.3577 114.489 34.6504 114.489 33.7273C114.489 32.9601 114.316 32.3727 113.981 31.9412C113.646 31.5096 113.162 31.2938 112.53 31.2938C111.935 31.2938 111.451 31.5096 111.067 31.9292C110.658 32.3607 110.472 32.9242 110.472 33.6075Z",
    fill: "#110626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.9 38.7861H130.225L128.861 35.1747H123.405L122.124 38.7861H120.449L125.391 25.907H126.958L131.9 38.7861ZM128.37 33.8234L126.348 28.3345C126.276 28.1551 126.216 27.8681 126.145 27.4735H126.109C126.049 27.8442 125.977 28.1312 125.905 28.3345L123.907 33.8234H128.37Z",
    fill: "url(#paint0_linear_3129_5567)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.31 38.7862H133.802V25.9191H135.31V38.7862Z",
    fill: "url(#paint1_linear_3129_5567)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4561 22.3693H15.6445L15.0211 16.9906H17.0796L16.4561 22.3693Z",
    fill: "url(#paint2_linear_3129_5567)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6802 22.9609L11.9392 23.2683L9.32791 18.5279L11.2217 17.7359L12.6802 22.9609Z",
    fill: "url(#paint3_linear_3129_5567)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5616 22.4765L13.7618 22.6302L12.1268 17.4643L14.1499 17.0742L14.5616 22.4765Z",
    fill: "url(#paint4_linear_3129_5567)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.79893 38.9781L9.37529 39.5455L6.023 43.8012L4.56446 42.3353L8.79893 38.9781Z",
    fill: "url(#paint5_linear_3129_5567)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8789 41.2357L12.62 41.5549L11.1261 46.7562L9.2324 45.9642L11.8789 41.2357Z",
    fill: "url(#paint6_linear_3129_5567)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2103 40.2437L10.8807 40.7047L8.41061 45.516L6.70506 44.3575L10.2103 40.2437Z",
    fill: "url(#paint7_linear_3129_5567)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.37373 24.983L8.79737 25.5623L4.5629 22.1932L6.02144 20.7274L9.37373 24.983Z",
    fill: "url(#paint8_linear_3129_5567)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.10193 26.4014L7.65496 27.0752L2.85589 24.5928L4.00861 22.8787L8.10193 26.4014Z",
    fill: "url(#paint9_linear_3129_5567)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9721 23.7776L10.2899 24.2268L6.83177 20.0657L8.54908 18.9309L10.9721 23.7776Z",
    fill: "url(#paint10_linear_3129_5567)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2541 39.0506L22.6777 39.6299L26.0536 43.921L27.5239 42.4433L23.2541 39.0506Z",
    fill: "url(#paint11_linear_3129_5567)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0894 41.3677L19.3248 41.6751L20.7951 46.9473L22.7242 46.1553L20.0894 41.3677Z",
    fill: "url(#paint12_linear_3129_5567)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7362 40.3989L21.054 40.8481L23.5006 45.7421L25.2414 44.5954L21.7362 40.3989Z",
    fill: "url(#paint13_linear_3129_5567)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3368 42.2649H15.5252L14.8901 47.7027H16.972L16.3368 42.2649Z",
    fill: "url(#paint14_linear_3129_5567)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.23 42.0043L17.4302 42.158L17.8536 47.6194L19.8885 47.2174L18.23 42.0043Z",
    fill: "url(#paint15_linear_3129_5567)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5257 41.9813L14.3256 42.1468L13.8433 47.5963L11.8084 47.1826L13.5257 41.9813Z",
    fill: "url(#paint16_linear_3129_5567)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5741 35.6813L6.87992 36.4497L2.11614 39.0976L1.32806 37.1708L6.5741 35.6813Z",
    fill: "url(#paint17_linear_3129_5567)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.09188 33.7785L6.24479 34.5942L1.05757 36.2491L0.657644 34.2041L6.09188 33.7785Z",
    fill: "url(#paint18_linear_3129_5567)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.39725 37.4195L7.84423 38.1052L3.66857 41.6279L2.52761 39.8902L7.39725 37.4195Z",
    fill: "url(#paint19_linear_3129_5567)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.98688 31.8637V32.6793L0.576172 33.3177V31.2253L5.98688 31.8637Z",
    fill: "url(#paint20_linear_3129_5567)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.91552 28.0345L6.59793 28.7911L1.36366 27.278L2.1635 25.3511L6.91552 28.0345Z",
    fill: "url(#paint21_linear_3129_5567)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.26908 29.8542L6.1044 30.658L0.68193 30.1733L1.09361 28.1282L6.26908 29.8542Z",
    fill: "url(#paint22_linear_3129_5567)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4646 22.9841L20.2174 23.2914L22.864 18.5629L20.9584 17.7709L19.4646 22.9841Z",
    fill: "url(#paint23_linear_3129_5567)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2063 23.8344L21.8768 24.2836L25.3937 20.1698L23.6882 19.0113L21.2063 23.8344Z",
    fill: "url(#paint24_linear_3129_5567)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6424 22.4866L18.4304 22.6521L20.1242 17.5099L18.1129 17.0962L17.6424 22.4866Z",
    fill: "url(#paint25_linear_3129_5567)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7232 24.9819L23.2878 25.5612L27.5222 22.1921L26.0637 20.7263L22.7232 24.9819Z",
    fill: "url(#paint26_linear_3129_5567)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8775 31.862V32.6777L31.2882 33.316V31.2237L25.8775 31.862Z",
    fill: "url(#paint27_linear_3129_5567)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9722 28.091L25.2898 28.8594L30.5358 27.3817L29.7477 25.443L24.9722 28.091Z",
    fill: "url(#paint28_linear_3129_5567)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2659 35.751L24.9484 36.5075L29.7004 39.191L30.5002 37.2641L25.2659 35.751Z",
    fill: "url(#paint29_linear_3129_5567)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6191 29.9583L25.772 30.7621L31.2063 30.3365L30.8064 28.2915L25.6191 29.9583Z",
    fill: "url(#paint30_linear_3129_5567)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4074 37.5127L23.9486 38.1983L28.089 41.7565L29.2535 40.0306L24.4074 37.5127Z",
    fill: "url(#paint31_linear_3129_5567)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0192 26.436L24.4662 27.1216L29.3358 24.6628L28.1948 22.9132L24.0192 26.436Z",
    fill: "url(#paint32_linear_3129_5567)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7481 33.8833L25.5834 34.6872L30.7589 36.4131L31.1823 34.368L25.7481 33.8833Z",
    fill: "url(#paint33_linear_3129_5567)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4072 25.9071L12.4629 32.8421H16.2655L18.4072 25.9071Z",
    fill: "url(#paint34_linear_3129_5567)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4512 38.7863L19.3954 31.8513H15.5859L13.4512 38.7863Z",
    fill: "url(#paint35_linear_3129_5567)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3129_5567",
    x1: 136.386,
    y1: 24.6683,
    x2: 124.627,
    y2: 38.5932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3129_5567",
    x1: 136.386,
    y1: 24.6683,
    x2: 124.627,
    y2: 38.5932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3129_5567",
    x1: 28.9308,
    y1: 18.6019,
    x2: 5.07659,
    y2: 43.2154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3129_5567",
    x1: 28.9308,
    y1: 18.6019,
    x2: 5.07659,
    y2: 43.2154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3129_5567",
    x1: 28.9308,
    y1: 18.6019,
    x2: 5.07659,
    y2: 43.2154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3129_5567",
    x1: 28.9308,
    y1: 18.6019,
    x2: 5.07659,
    y2: 43.2154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3129_5567",
    x1: 28.9308,
    y1: 18.6019,
    x2: 5.07659,
    y2: 43.2154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3129_5567",
    x1: 28.9308,
    y1: 18.6019,
    x2: 5.07659,
    y2: 43.2154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3129_5567",
    x1: 28.9308,
    y1: 18.6019,
    x2: 5.07659,
    y2: 43.2154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3129_5567",
    x1: 28.9308,
    y1: 18.6019,
    x2: 5.07659,
    y2: 43.2154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3129_5567",
    x1: 28.9308,
    y1: 18.6019,
    x2: 5.07659,
    y2: 43.2154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3129_5567",
    x1: 28.9308,
    y1: 18.6019,
    x2: 5.07659,
    y2: 43.2154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3129_5567",
    x1: 28.9308,
    y1: 18.6019,
    x2: 5.07659,
    y2: 43.2154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3129_5567",
    x1: 28.9308,
    y1: 18.6019,
    x2: 5.07659,
    y2: 43.2154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3129_5567",
    x1: 28.9308,
    y1: 18.6019,
    x2: 5.07659,
    y2: 43.2154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3129_5567",
    x1: 28.9308,
    y1: 18.6019,
    x2: 5.07659,
    y2: 43.2154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3129_5567",
    x1: 28.9308,
    y1: 18.6019,
    x2: 5.07659,
    y2: 43.2154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3129_5567",
    x1: 28.9308,
    y1: 18.6019,
    x2: 5.07659,
    y2: 43.2154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3129_5567",
    x1: 28.9308,
    y1: 18.6019,
    x2: 5.07659,
    y2: 43.2154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3129_5567",
    x1: 28.9308,
    y1: 18.6019,
    x2: 5.07659,
    y2: 43.2154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3129_5567",
    x1: 28.9308,
    y1: 18.6019,
    x2: 5.07659,
    y2: 43.2154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3129_5567",
    x1: 28.9308,
    y1: 18.6019,
    x2: 5.07659,
    y2: 43.2154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3129_5567",
    x1: 28.9308,
    y1: 18.6019,
    x2: 5.07659,
    y2: 43.2154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_3129_5567",
    x1: 28.9308,
    y1: 18.6019,
    x2: 5.07659,
    y2: 43.2154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_3129_5567",
    x1: 28.9308,
    y1: 18.6019,
    x2: 5.07659,
    y2: 43.2154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_3129_5567",
    x1: 28.9308,
    y1: 18.6019,
    x2: 5.07659,
    y2: 43.2154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_3129_5567",
    x1: 28.9308,
    y1: 18.6019,
    x2: 5.07659,
    y2: 43.2154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_3129_5567",
    x1: 28.9308,
    y1: 18.6019,
    x2: 5.07659,
    y2: 43.2154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_3129_5567",
    x1: 28.9308,
    y1: 18.6019,
    x2: 5.07659,
    y2: 43.2154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_3129_5567",
    x1: 28.9308,
    y1: 18.6019,
    x2: 5.07659,
    y2: 43.2154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_3129_5567",
    x1: 28.9308,
    y1: 18.6019,
    x2: 5.07659,
    y2: 43.2154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_3129_5567",
    x1: 28.9308,
    y1: 18.6019,
    x2: 5.07659,
    y2: 43.2154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_3129_5567",
    x1: 28.9308,
    y1: 18.6019,
    x2: 5.07659,
    y2: 43.2154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_3129_5567",
    x1: 28.9308,
    y1: 18.6019,
    x2: 5.07659,
    y2: 43.2154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_3129_5567",
    x1: 17.5382,
    y1: 26.923,
    x2: 12.6908,
    y2: 31.0786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_3129_5567",
    x1: 18.5265,
    y1: 32.8672,
    x2: 13.679,
    y2: 37.0228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3129_5567"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 136,
    height: 34,
    fill: "white",
    transform: "translate(0 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoweredBy);
export default __webpack_public_path__ + "static/media/PoweredBy.000e76bfcbb70265db81e8cc0f3c5580.svg";
export { ForwardRef as ReactComponent };